import React from 'react';
import { readyToServeIndexes, readyToServeCount, waitingOnKitchenCount } from '../lib/orderFlow';

// Informational only — shows what's ready to serve (bar + kitchen) and what's still cooking.
// The actual serve action is a single button on the parent card.
export function ReadyToServeSection({ order }) {
    const nonKitchenIdx = readyToServeIndexes(order, 'non_kitchen');
    const kitchenIdx = readyToServeIndexes(order, 'kitchen');
    const waitCount = waitingOnKitchenCount(order);
    if (!nonKitchenIdx.length && !kitchenIdx.length && !waitCount) return null;
    const items = order.items || [];
    const renderList = (idxs) => (
        <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 0.2rem 0', fontSize: '0.85rem' }}>
            {idxs.map((i) => (
                <li key={i}>• {items[i].quantity}× {items[i].product_name}
                    {items[i].variant_name ? <span style={{ opacity: 0.8 }}> · {items[i].variant_name}</span> : null}</li>
            ))}
        </ul>
    );
    return (
        <div style={{ margin: '0.5rem 0 0.7rem' }}>
            {nonKitchenIdx.length > 0 && (
                <div style={{ padding: '0.55rem 0.7rem', borderRadius: 8, background: 'rgba(255,200,80,0.08)', border: '1px solid rgba(255,200,80,0.25)', marginBottom: 6 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
                        <strong style={{ fontSize: '0.8rem' }}>⚡ GATA DE SERVIT (de la bar)</strong>
                        <span className="badge badge-amber">{readyToServeCount(order, 'non_kitchen')}</span>
                    </div>
                    {renderList(nonKitchenIdx)}
                </div>
            )}
            {kitchenIdx.length > 0 && (
                <div style={{ padding: '0.55rem 0.7rem', borderRadius: 8, background: 'rgba(80,255,180,0.08)', border: '1px solid rgba(80,255,180,0.25)', marginBottom: 6 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
                        <strong style={{ fontSize: '0.8rem' }}>🍽 GATA DIN BUCĂTĂRIE</strong>
                        <span className="badge badge-cyan">{readyToServeCount(order, 'kitchen')}</span>
                    </div>
                    {renderList(kitchenIdx)}
                </div>
            )}
            {waitCount > 0 && (
                <div style={{ padding: '0.4rem 0.7rem', borderRadius: 8, background: 'rgba(120,120,120,0.08)', border: '1px dashed var(--border-faint)', fontSize: '0.78rem', color: 'var(--text-muted)' }}>
                    ⏳ {waitCount} produs(e) încă în bucătărie
                </div>
            )}
        </div>
    );
}
